import { startOfYesterday, endOfToday } from "date-fns";

export const COMPANIES_FILTERS = [
  {
    key: "companyId",
    label: "Id компании",
    type: "string",
  },
  {
    key: "companyName",
    label: "Наименование компании",
    type: "string",
  },
];
export const MERCHANTS_FILTERS = [
  {
    key: "companyId",
    label: "Id компании",
    type: "string",
  },
  {
    key: "merchantIds",
    label: "Id точек обслуживания",
    type: "string",
  },
  {
    key: "merchantName",
    label: "Наименование точки обслуживания",
    type: "string",
  },
];
export const TERMINALS_FILTERS = [
  {
    key: "companyId",
    label: "Id компании",
    type: "string",
  },
  {
    key: "merchantId",
    label: "Id точки обслуживания",
    type: "string",
  },
  {
    key: "terminalIds",
    label: "Id терминалов (маска по символу %)",
    type: "string",
  },
];
export const TRANSACTIONS_FILTERS = [
  {
    key: "sortById",
    label: "Сортировать по id",
    type: "select",
    hidden: true,
    options: {
      placeholder: "По умолчанию",
      chooseAllName: "По умолчанию",
      options: [
        { value: "ASC", label: "По возрастанию" },
        { value: "DSC", label: "По убыванию" },
      ],
    },
  },
  {
    key: "sortByDate",
    label: "Сортировать по дате",
    type: "select",
    hidden: true,
    options: {
      placeholder: "По умолчанию",
      chooseAllName: "По умолчанию",
      options: [
        { value: "ASC", label: "Самые старые" },
        { value: "DSC", label: "Самые новые" },
      ],
    },
  },
  {
    key: "dates",
    type: "date-range",
    // default: {
    //   startDate: startOfYesterday(),
    //   endDate: endOfToday(),
    // },
    isValid: ({ startDate, endDate }) => startDate && endDate,
    required: true,
    requiredMessage: "Введите даты",
  },
  {
    key: "isSuccessful",
    label: "Статус",
    type: "select",
    numeric: true,
    options: {
      placeholder: "Все",
      chooseAllName: "Все",
      options: [
        { value: 0, label: "Только неуспешные" },
        { value: 1, label: "Только успешные" },
      ],
    },
  },
  {
    key: "transactionType",
    label: "Тип транзакции",
    type: "select",
    numeric: true,
    options: {
      placeholder: "По всем типам",
      chooseAllName: "По всем типам",
      options: [
        { value: 0, label: "Отмены" },
        { value: 1, label: "Оплаты" },
        { value: 2, label: "Возвраты" },
        {
          value: 3,
          label: "Выдача",
        },
        {
          value: 4,
          label: "p2p",
        },
      ],
    },
  },
  {
    key: "originType",
    label: "Источник транзакции",
    type: "select",
    numeric: true,
    options: {
      placeholder: "По всем источникам",
      chooseAllName: "По всем источникам",
      options: [
        { value: 1, label: "Наша карта в нашем устр." },
        { value: 2, label: "Чужая карта в нашем устр." },
        { value: 3, label: "Наша карта в чужом устр." },
        {
          value: 4,
          label: "Чужая карта в чужом устр.",
        },
      ],
    },
  },
  {
    key: "companyId",
    label: "Id компании",
    type: "string",
  },
  {
    key: "merchantId",
    label: "Id точки обслуживания",
    type: "string",
  },
  {
    key: "terminalId",
    label: "Id терминала",
    type: "string",
  },
  {
    key: "transactionId",
    label: "Id транзакции",
    type: "string",
  },
  {
    key: "pan",
    label: "PAN (4 цифры / маска по символу %)",
    type: "string",
    additional: true,
    required: true,
    // not set or more than 4 digits
    isValid: (value) => !value || value.replace(/\D+/g, "").length >= 4,
    requiredMessage: "PAN должен содержать не менее 4 цифр",
    // keep only digits and %
    inputFormatter: (value) => value.replace(/[^0-9%]/g, ""),
  },
  {
    key: "authcode",
    label: "Код авторизации",
    type: "string",
    additional: true,
  },
  {
    key: "rrn",
    label: "RRN",
    type: "string",
    additional: true,
  },
];



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-processing/Data/config.js